import { render, staticRenderFns } from "./creatSlide.vue?vue&type=template&id=bdaada8a&scoped=true"
import script from "./creatSlide.vue?vue&type=script&lang=js"
export * from "./creatSlide.vue?vue&type=script&lang=js"
import style0 from "./creatSlide.vue?vue&type=style&index=0&id=bdaada8a&prod&lang=scss"
import style1 from "./creatSlide.vue?vue&type=style&index=1&id=bdaada8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaada8a",
  null
  
)

export default component.exports